import BaseInput from "Components/Base/BaseInput";
import { BaseSelect } from "Components/Base/BaseSelect";
import {
  ProformaLabel,
} from "Components/constants/ProformaInvoice";
import {
  InputPlaceHolder,
  SelectPlaceHolder,
} from "Components/constants/validation";
import React from "react";
import { FormikProps } from "formik";

interface FormFieldsProps {
  formik: FormikProps<any>;
  workOrderOptions: any;
  quotationOption: any;
  proformaId: any;
  setWork:any;
}
const FormFields: React.FC<FormFieldsProps> = ({
  formik,
  workOrderOptions,
  quotationOption,
  proformaId,
  setWork,
}) => {
  return (
    <form onSubmit={formik.handleSubmit} className="mt-2 mb-4">
      <div className="row">
        <div className="col-md-3 col-sm-6 col-12">
          <BaseSelect
            name="workOrderNo"
            label={ProformaLabel.WorkOrderNo}
            options={workOrderOptions}
            value={formik.values.workOrderNo}
            placeholder={SelectPlaceHolder(ProformaLabel.WorkOrderNo)}
            handleChange={(field: any, value: any) => {
              formik.setFieldValue(field, value);
              setWork(false);
            }}
            handleBlur={formik.handleBlur}
            error={formik.errors.workOrderNo}
            touched={formik.touched.workOrderNo}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="vendorName"
            label={ProformaLabel.VendorName}
            placeholder={InputPlaceHolder(ProformaLabel.VendorName)}
            value={formik.values.vendorName}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.vendorName}
            touched={formik.touched.vendorName}
            disabled={true}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="vendorId"
            label={ProformaLabel.VendorID}
            placeholder={InputPlaceHolder(ProformaLabel.VendorID)}
            value={formik.values.vendorId}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.vendorId}
            touched={formik.touched.vendorId}
            disabled={true}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="date"
            name="proformaInvoiceDT"
            label={ProformaLabel.ProformaInvoiceDT}
            placeholder={InputPlaceHolder(ProformaLabel.ProformaInvoiceDT)}
            value={formik.values.proformaInvoiceDT}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.proformaInvoiceDT}
            touched={formik.touched.proformaInvoiceDT}
            required
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="taxableValue"
            label={ProformaLabel.TaxableValue}
            placeholder={InputPlaceHolder(ProformaLabel.TaxableValue)}
            value={formik.values.taxableValue}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.taxableValue}
            touched={formik.touched.taxableValue}
            disabled={true}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="gst"
            label={ProformaLabel.GST}
            placeholder={InputPlaceHolder(ProformaLabel.GST)}
            value={formik.values.gst}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.gst}
            touched={formik.touched.gst}
            disabled={true}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="taxAmount"
            label={ProformaLabel.TaxAmt}
            placeholder={InputPlaceHolder(ProformaLabel.TaxAmt)}
            value={formik.values.taxAmount}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.taxAmount}
            touched={formik.touched.taxAmount}
            disabled={true}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="warranty"
            label={ProformaLabel.Warranty}
            placeholder={InputPlaceHolder(ProformaLabel.Warranty)}
            value={formik.values.warranty}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.warranty}
            touched={formik.touched.warranty}
            required
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="textarea"
            name="remarks"
            label={ProformaLabel.Remarks}
            placeholder={InputPlaceHolder(ProformaLabel.Remarks)}
            value={formik.values.remarks}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.remarks}
            touched={formik.touched.remarks}
            rows={1}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="textarea"
            name="shipTo"
            label={ProformaLabel.ShipTo}
            placeholder={InputPlaceHolder(ProformaLabel.ShipTo)}
            value={formik.values.shipTo}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.shipTo}
            touched={formik.touched.shipTo}
            rows={1}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="textarea"
            name="billTo"
            label={ProformaLabel.BillTo}
            placeholder={InputPlaceHolder(ProformaLabel.BillTo)}
            value={formik.values.billTo}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.billTo}
            touched={formik.touched.billTo}
            rows={1}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="deliveryNote"
            label={ProformaLabel.DeliveryNote}
            placeholder={InputPlaceHolder(ProformaLabel.DeliveryNote)}
            value={formik.values.deliveryNote}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.deliveryNote}
            touched={formik.touched.deliveryNote}
            required
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="date"
            name="deliveryDate"
            label={ProformaLabel.DeliveryDate}
            placeholder={InputPlaceHolder(ProformaLabel.DeliveryDate)}
            value={formik.values.deliveryDate}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.deliveryDate}
            touched={formik.touched.deliveryDate}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="termsOfPayment"
            label={ProformaLabel.TermsOfPayment}
            placeholder={InputPlaceHolder(ProformaLabel.TermsOfPayment)}
            value={formik.values.termsOfPayment}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.termsOfPayment}
            touched={formik.touched.termsOfPayment}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseSelect
            name="quoteNo"
            label={ProformaLabel.QuoteNo}
            options={quotationOption}
            placeholder={SelectPlaceHolder(ProformaLabel.QuoteNo)}
            value={formik.values.quoteNo}
            handleChange={(field: any, value: any) => {
              formik.setFieldValue(field, value);
            }}
            handleBlur={formik.handleBlur}
            error={formik.errors.quoteNo}
            touched={formik.touched.quoteNo}
            isDisabled={true}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="date"
            name="referenceNoDate"
            label={ProformaLabel.ReferenceNoDate}
            placeholder={InputPlaceHolder(ProformaLabel.ReferenceNoDate)}
            value={formik.values.referenceNoDate}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.referenceNoDate}
            touched={formik.touched.referenceNoDate}
            disabled={true}
            required
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="vehicleRegNo"
            label={ProformaLabel.VehicleRegNo}
            placeholder={InputPlaceHolder(ProformaLabel.VehicleRegNo)}
            value={formik.values.vehicleRegNo}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.vehicleRegNo}
            touched={formik.touched.vehicleRegNo}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="serialNo"
            label={ProformaLabel.SerialNo}
            placeholder={InputPlaceHolder(ProformaLabel.SerialNo)}
            value={formik.values.serialNo}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.serialNo}
            touched={formik.touched.serialNo}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="engineNo"
            label={ProformaLabel.EngineNo}
            placeholder={InputPlaceHolder(ProformaLabel.EngineNo)}
            value={formik.values.engineNo}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.engineNo}
            touched={formik.touched.engineNo}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="buyerOrderNo"
            label={ProformaLabel.BuyerOrderNo}
            placeholder={InputPlaceHolder(ProformaLabel.BuyerOrderNo)}
            value={formik.values.buyerOrderNo}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.buyerOrderNo}
            touched={formik.touched.buyerOrderNo}
            disabled={true}
            required
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="date"
            name="buyerDate"
            label={ProformaLabel.BuyerDate}
            placeholder={InputPlaceHolder(ProformaLabel.BuyerDate)}
            value={formik.values.buyerDate}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.buyerDate}
            touched={formik.touched.buyerDate}
            disabled={true}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="dispatchedThrough"
            label={ProformaLabel.DispatchedThrough}
            placeholder={InputPlaceHolder(ProformaLabel.DispatchedThrough)}
            value={formik.values.dispatchedThrough}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.dispatchedThrough}
            touched={formik.touched.dispatchedThrough}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="destination"
            label={ProformaLabel.Destination}
            placeholder={InputPlaceHolder(ProformaLabel.Destination)}
            value={formik.values.destination}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.destination}
            touched={formik.touched.destination}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="motorVehicleNo"
            label={ProformaLabel.MotorVehicleNo}
            placeholder={InputPlaceHolder(ProformaLabel.MotorVehicleNo)}
            value={formik.values.motorVehicleNo}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.motorVehicleNo}
            touched={formik.touched.motorVehicleNo}
            required
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="textarea"
            name="deliveryTerms"
            label={ProformaLabel.DeliveryTerms}
            placeholder={InputPlaceHolder(ProformaLabel.DeliveryTerms)}
            value={formik.values.deliveryTerms}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.deliveryTerms}
            touched={formik.touched.deliveryTerms}
            rows={1}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="discount"
            label={ProformaLabel.Discount}
            placeholder={InputPlaceHolder(ProformaLabel.Discount)}
            value={formik.values.discount}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.discount}
            touched={formik.touched.discount}
            disabled={true}
          />
        </div>
      </div>
      <div className="w-full border-bottom mt-3 mb-1"></div>
    </form>
  );
};

export default FormFields;
